/**
 * @file 新闻列表页
 * @author FengGuang(fengguang01@baidu.com)
 */

import React from 'react';
import {Pagination} from 'antd';

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import CategoryList from './components/category-list/CategoryList';


import TagList from './components/tag-list/TagList';
import NewsList from './components/news-list/NewsList';
import useNewsStore from './newsHooks';

// 改变 pagination 组件的内容，为其加上链接
const paginationItemRender = (
    page: number,
    type: string,
    originalElement: React.ReactElement<HTMLElement>
): React.ReactNode => {
    // 其元素根节点是 a 标签
    const org = originalElement as React.ReactElement<HTMLAnchorElement>;
    const pageUrlSearch = new URLSearchParams(window.location.search.slice(1));
    pageUrlSearch.set('page', '' + page);
    return React.cloneElement(org, {
        href: `/support/news?${pageUrlSearch.toString()}`
    });
};

const News: React.FC = () => {
    const {
        newsModule,
        currentTag,
        tagList,
        categoryList,
        currentCategory,
        newsList,
        recommendList,
        pagination,
    } = useNewsStore();

    return (
        <div className="page paddle-news-page">
            <Header />
            <div className="paddle-news-page-container">
                <div className="paddle-news">
                    <div className="ai-platform-wrap">
                        <div className="paddle-news-content">
                            <div className="paddle-news-main">
                                <CategoryList
                                    newsModule={newsModule}
                                    currentCategory={currentCategory}
                                    categoryList={categoryList}
                                />
                                <TagList
                                    currentTag={currentTag}
                                    tagList={tagList}
                                />
                                <NewsList newsList={newsList} />
                                <Pagination
                                    {...pagination}
                                    className="ai-platform-pagination paddle-news-pagination"
                                    hideOnSinglePage
                                    // @ts-ignore
                                    itemRender={paginationItemRender}
                                />
                            </div>
                            <div className="paddle-news-recommend">
                                <div className="paddle-news-recommend-title">
                                    小编推荐
                                </div>
                                <div className="paddle-news-recommend-list">
                                    {recommendList.map(item => (
                                        <a
                                            className="paddle-news-recommend-item"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            key={item.id}
                                            href={item.link}
                                        >
                                            {item.title}
                                        </a>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default News;
